export const blobFileUrl = (downloadedFile, mimetype = "application/pdf") => {
  const blob = new Blob([downloadedFile.data], {
    type: mimetype,
  });
  const fileUrl = URL.createObjectURL(blob);
  return fileUrl;
};
